import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const WALKTHROUGH_TASK_ITEMS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('WALKTHROUGH_TASK_ITEMS');
export const WALKTHROUGH_TASK_ITEMS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	WALKTHROUGH_TASK_ITEMS_CRUD_ACTION_CONSTANTS
);
